export type OrganizationRequisiteField =
  | "NAME"
  | "INN"
  | "KPP"
  | "OGRN"
  | "CONTACTS"
  | "LEGAL_ADDRESS";

export interface OrganizationRequisiteChange {
  field: OrganizationRequisiteField;
  label: string;
  oldValue: string;
  newValue: string;
}

export interface OrganizationRequisiteValue {
  field: OrganizationRequisiteField;
  label: string;
  value: string;
}

export interface OrganizationRequisitesChanges {
  organizationId: string;
  organizationName: string;
  organizationRole: string;
  titleSectionId: string;
  requisites: OrganizationRequisiteValue[];
  fields: OrganizationRequisiteChange[];
}

export interface AmendmentResponsibleSnapshot {
  id: string;
  name: string;
  organization: string;
  position: string;
  document: string;
  documentUrl?: string;
  email: string;
  registryNumber: string;
  nostroyNumber: string;
  phone: string;
}

export const buildSystemAmendmentReason = (
  changes: OrganizationRequisitesChanges,
) => {
  const details = changes.fields
    .map(
      ({ label, oldValue, newValue }) =>
        `${label}: ${oldValue || "—"} на ${newValue || "—"}`,
    )
    .join(". ");

  return `Обновление реквизитов организации ${changes.organizationName}. ${details}`;
};
